module.exports = __webpack_public_path__ + "img/EIXO02.63d6bc69.png";